import { ChecklightSessionStatus } from '@thesavingsgroup/enums/ChecklightSessionStatus';

export const COMPLETE_APPLICATION_STATUSES: string[] = [
  'NEW_LEAD',
  'WORKING_LEAD',
  ChecklightSessionStatus.QUEUED_FOR_SUBMISSION,
  ChecklightSessionStatus.FAILED_SUBMISSION,
];
